import { IPermissionSetGrouping } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'
import { AccessGrantPermissionSet, accessGrantPermissionSetGrouping } from './AccessGrantPermissions'
import { AdminUserPermissionSet, adminUserPermissionSetGrouping } from './AdminUserPermissions'
import { AiAgentPermissionSet, aiAgentPermissionSetGrouping } from './AiAgentPermissions'
import { AiPermissionSet, aiPermissionSetGrouping } from './AiPermissions'
import { AnalyticsPermissionSet, analyticsPermissionSetGrouping } from './AnalyticsPermissions'
import {
  AnalyticsTemplateLibraryPermissionSet,
  analyticsTemplateLibraryPermissionSetGrouping,
} from './AnalyticsTemplateLibraryPermissions'
import { AnnouncementPermissionSet, announcementPermissionSetGrouping } from './AnnouncementPermissions'
import { ApiKeyPermissionSet, apiKeyPermissionSetGrouping } from './ApiKeyPermissions'
import { AppPermissionSet, appPermissionSetGrouping } from './AppPermissions'
import { AuditLogPermissionSet, auditLogPermissionSetGrouping } from './AuditLogPermissions'
import {
  AuthorizationGroupMembershipPermissionSet,
  authorizationGroupMembershipPermissionSetGrouping,
} from './AuthorizationGroupMembershipPermissions'
import {
  AuthorizationGroupPermissionSet,
  authorizationGroupPermissionSetGrouping,
} from './AuthorizationGroupPermissions'
import { AuthorizationRolePermissionSet, authorizationRolePermissionSetGrouping } from './AuthorizationRolePermissions'
import { BulkMessagePermissionSet, bulkMessagePermissionSetGrouping } from './BulkMessagePermissions'
import {
  CancellationReasonPermissionSet,
  cancellationReasonPermissionSetGrouping,
} from './CancellationReasonPermissions'
import { ChargePermissionSet, chargePermissionSetGrouping } from './ChargePermissions'
import { CommentPermissionSet, commentPermissionSetGrouping } from './CommentPermissions'
import { CustomLinkPermissionSet, customLinkPermissionSetGrouping } from './CustomLinkPermissions'
import {
  DataRetentionSchedulePermissionSet,
  dataRetentionSchedulePermissionSetGrouping,
} from './DataRetentionSchedulePermissions'
import { DevicePermissionSet, devicePermissionSetGrouping } from './DevicePermission'
import { DirectorySyncPermissionSet, directorySyncPermissionSetGrouping } from './DirectorySyncPermissions'
import { DriverBreakPermissionSet, driverBreakPermissionSetGrouping } from './DriverBreakPermissions'
import { DriverPermissionSet, driverPermissionSetGrouping } from './DriverPermissions'
import { DriverUserPermissionSet, driverUserPermissionSetGrouping } from './DriverUserPermissions'
import { DutyDelayPermissionSet, dutyDelayPermissionSetGrouping } from './DutyDelayPermissions'
import { DutyPermissionSet, dutyPermissionSetGrouping } from './DutyPermissions'
import { DutyRequestOfferPermissionSet, dutyRequestOfferPermissionSetGrouping } from './DutyRequestOfferPermissions'
import { EamAssetPermissionSet, eamAssetPermissionSetGrouping } from './EamAssetPermissions'
import { EamContactPermissionSet, eamContactPermissionSetGrouping } from './EamContactPermissions'
import { EamEnergyEntryPermissionSet, eamEnergyEntryPermissionSetGrouping } from './EamEnergyEntryPermissions'
import { EamInspectionFormPermissionSet, eamInspectionFormPermissionSetGrouping } from './EamInspectionFormPermissions'
import { EamInspectionPermissionSet, eamInspectionPermissionSetGrouping } from './EamInspectionPermissions'
import { EamInventoryPermissionSet, eamInventoryPermissionSetGrouping } from './EamInventoryPermissions'
import { EamIssuePermissionSet, eamIssuePermissionSetGrouping } from './EamIssuePermissions'
import { EamLocationPermissionSet, eamLocationPermissionSetGrouping } from './EamLocationPermissions'
import { EamMeterEntryPermissionSet, eamMeterEntryPermissionSetGrouping } from './EamMeterEntryPermissions'
import { EamPartPermissionSet, eamPartPermissionSetGrouping } from './EamPartPermissions'
import { EamPurchaseOrderPermissionSet, eamPurchaseOrderPermissionSetGrouping } from './EamPurchaseOrderPermissions'
import { EamServiceEntryPermissionSet, eamServiceEntryPermissionSetGrouping } from './EamServiceEntryPermissions'
import { EamServiceProgramPermissionSet, eamServiceProgramPermissionSetGrouping } from './EamServiceProgramPermissions'
import {
  EamServiceReminderPermissionSet,
  eamServiceReminderPermissionSetGrouping,
} from './EamServiceReminderPermissions'
import {
  EamServiceSchedulePermissionSet,
  eamServiceSchedulePermissionSetGrouping,
} from './EamServiceSchedulePermissions'
import {
  EamServiceScheduleTaskPermissionSet,
  eamServiceScheduleTaskPermissionSetGrouping,
} from './EamServiceScheduleTaskPermissions'
import { EamServiceTaskPermissionSet, eamServiceTaskPermissionSetGrouping } from './EamServiceTaskPermissions'
import { EamSettingPermissionSet, eamSettingPermissionSetGrouping } from './EamSettingPermissions'
import { EamVendorPermissionSet, eamVendorPermissionSetGrouping } from './EamVendorPermissions'
import { EamWorkOrderPermissionSet, eamWorkOrderPermissionSetGrouping } from './EamWorkOrderPermissions'
import {
  EdiBrokerConfigurationPermissionSet,
  ediBrokerConfigurationPermissionSetGrouping,
} from './EdiBrokerConfigurationPermissions'
import {
  EdiEligibilityCheckPermissionSet,
  ediEligibilityCheckPermissionSetGrouping,
} from './EdiEligibilityCheckPermissions'
import {
  CasePermissionSet,
  casePermissionSetGrouping,
  CaseTypePermissionSet,
  caseTypePermissionSetGrouping,
  FormPermissionSet,
  formPermissionSetGrouping,
  LetterPermissionSet,
  letterPermissionSetGrouping,
  NylasAdminGrantPermissionSet,
  nylasAdminGrantPermissionSetGrouping,
} from './EngagePermissions'
import { EngageReportingPermissionSet, engageReportingPermissionSetGrouping } from './EngageReportingPermissions'
import { EventPermissionSet, eventPermissionSetGrouping } from './EventPermissions'
import { FarePassPermissionSet, farePassPermissionSetGrouping } from './FarePassPermissions'
import { FareRulePermissionSet, fareRulePermissionSetGrouping } from './FareRulePermissions'
import { FavoriteLocationPermissionSet, favoriteLocationPermissionSetGrouping } from './FavoriteLocationPermissions'
import {
  FixedRouteForDisplayPermissionSet,
  fixedRouteForDisplayPermissionSetGrouping,
} from './FixedRouteForDisplayPermissions'
import { FleetPermissionSet, fleetPermissionSetGrouping } from './FleetPermissions'
import { GroupPermissionSet, groupPermissionSetGrouping } from './GroupPermissions'
import { gtfsPermissionSetGrouping, GtfsPermissionsSet } from './GtfsPermissions'
import { GtfsRealtimePermissionSet, gtfsRealtimePermissionSetGrouping } from './GtfsRealtimePermissions'
import { IvrPermissionSet, ivrPermissionSetGrouping } from './IvrPermissions'
import { JourneyPermissionSet, journeyPermissionSetGrouping } from './JourneyPermissions'
import { KnowledgeEntryPermissionSet, knowledgeEntryPermissionSetGrouping } from './KnowledgeEntryPermissions'
import { LaunchReportingPermissionSet, launchReportingPermissionSetGrouping } from './LaunchReportingPermissions'
import { MatchingOutcomePermissionSet, matchingOutcomePermissionSetGrouping } from './MatchingOutcomePermissions'
import {
  NotificationDeliveryPolicyPermissionSet,
  NotificationDeliveryPolicyPermissionSetGrouping,
} from './NotificationDeliveryPolicyPermissions'
import {
  NotificationSettingPermissionSet,
  notificationSettingPermissionSetGrouping,
} from './NotificationSettingPermissions'
import { OperationalAlertsPermissionSet, operationalAlertsPermissionSetGrouping } from './OperationalAlertsPermissions'
import { OrganizationPermissionSet, organizationPermissionSetGrouping } from './OrganizationPermissions'
import { PaymentMethodPermissionSet, paymentMethodPermissionSetGrouping } from './PaymentMethodPermissions'
import { PaymentMethodTypePermissionSet, paymentMethodTypePermissionSetGrouping } from './PaymentMethodTypePermissions'
import { PhoneNumberPermissionSet, phoneNumberPermissionSetGrouping } from './PhoneNumberPermissions'
import { PlatformPermissionSet, platformPermissionSetGrouping } from './PlatformPermissions'
import { PromoPermissionSet, promoPermissionSetGrouping } from './PromoPermissions'
import { ProviderPermissionSet, providerPermissionSetGrouping } from './ProviderPermissions'
import { QuickReplyPermissionSet, quickReplyPermissionSetGrouping } from './QuickReplyPermissions'
import { RealizePermissionSet, realizePermissionSetGrouping } from './RealizePermissions'
import { RequestPermissionSet, requestPermissionSetGrouping } from './RequestPermissions'
import { ResolveReportingPermissionSet, resolveReportingPermissionSetGrouping } from './ResolveReportingPermissions'
import { ReviewPermissionSet, reviewPermissionSetGrouping } from './ReviewPermissions'
import {
  RiderDriverRestrictionPermissionSet,
  riderDriverRestrictionPermissionSetGrouping,
} from './RiderDriverRestrictionPermissions'
import {
  RiderOnboardingFlowPermissionSet,
  riderOnboardingFlowPermissionSetGrouping,
  RiderPermissionSet,
  riderPermissionSetGrouping,
} from './RiderPermissions'
import {
  RiderRepresentativePermissionSet,
  riderRepresentativePermissionSetGrouping,
} from './RiderRepresentativePermissions'
import {
  RiderRiderRestrictionPermissionSet,
  riderRiderRestrictionPermissionSetGrouping,
} from './RiderRiderRestrictionPermissions'
import { RiderUserPermissionSet, riderUserPermissionSetGrouping } from './RiderUserPermissions'
import {
  RiderVehicleTypeRestrictionPermissionSet,
  riderVehicleTypeRestrictionPermissionSetGrouping,
} from './RiderVehicleTypeRestrictionPermissions'
import { ServicePermissionSet, servicePermissionSetGrouping } from './ServicePermissions'
import {
  SidebarProductVisibilityPermissionSet,
  sidebarProductVisibilityPermissionSetGrouping,
} from './SidebarProductVisibilityPermissions'
import {
  DefaultSuperAdminPermissionSet,
  defaultSuperAdminPermissionSetGrouping,
} from './SuperAdmin/DefaultSuperAdminPermissions'
import {
  EngineeringLeadPermissionSet,
  engineeringLeadPermissionSetGrouping,
} from './SuperAdmin/EngineeringLeadPermissions'
import {
  PartnerSuccessPermissionSet,
  partnerSuccessPermissionSetGrouping,
} from './SuperAdmin/PartnerSuccessPermissions'
import {
  RootSuperAdminPermissionSet,
  rootSuperAdminPermissionSetGrouping,
} from './SuperAdmin/RootSuperAdminPermissions'
import {
  SiteReliabilityEngineerPermissionSet,
  siteReliabilityEngineerPermissionSetGrouping,
} from './SuperAdmin/SiteReliabilityEngineerPermissions'
import {
  SuperAdminTestRolePermissionSet,
  superAdminTestRolePermissionSetGrouping,
} from './SuperAdmin/SuperAdminTestPermission'
import { TicketPermissionSet, ticketPermissionSetGrouping } from './TicketPermissions'
import { TimeRulePermissionSet, timeRulePermissionSetGrouping } from './TimeRulePermissions'
import { TipPermissionSet, tipPermissionSetGrouping } from './TipPermissions'
import { TripGroupPermissionSet, tripGroupPermissionSetGrouping } from './TripGroupPermissions'
import { UserBanPermissionSet, userBanPermissionSetGrouping } from './UserBanPermissions'
import {
  UserFleetAgreementPermissionSet,
  userFleetAgreementPermissionSetGrouping,
} from './UserFleetAgreementPermissions'
import { UserOnlyTokenPermissionSet, userOnlyTokenPermissionSetGrouping } from './UserOnlyTokenPermissions'
import { UserOwnPermissionSet, userOwnPermissionSetGrouping } from './UserOwnPermissions'
import { VehiclePermissionSet, vehiclePermissionSetGrouping } from './VehiclePermissions'
import { VehicleTypePermissionSet, vehicleTypePermissionSetGrouping } from './VehicleTypePermissions'
import { WebhookPermissionSet, webhookPermissionSetGrouping } from './WebhookPermissions'
import { WorkflowPermissionSet, workflowPermissionSetGrouping } from './WorkflowPermissions'
/**
 * Please export all permission set grouping files here
 */
export * from './AdminUserPermissions'
export * from './AnalyticsTemplateLibraryPermissions'
export * from './AiAgentPermissions'
export * from './AiPermissions'
export * from './AnalyticsPermissions'
export * from './AnnouncementPermissions'
export * from './ApiKeyPermissions'
export * from './AppPermissions'
export * from './AuditLogPermissions'
export * from './AuthorizationGroupPermissions'
export * from './BulkMessagePermissions'
export * from './CancellationReasonPermissions'
export * from './ChargePermissions'
export * from './CommentPermissions'
export * from './CustomLinkPermissions'
export * from './DataRetentionSchedulePermissions'
export * from './DevicePermission'
export * from './DriverBreakPermissions'
export * from './DriverPermissions'
export * from './DriverUserPermissions'
export * from './DutyDelayPermissions'
export * from './DutyPermissions'
export * from './DutyRequestOfferPermissions'
export * from './EamAssetPermissions'
export * from './EamContactPermissions'
export * from './EamEnergyEntryPermissions'
export * from './EamInspectionFormPermissions'
export * from './EamInspectionPermissions'
export * from './EamInventoryPermissions'
export * from './EamIssuePermissions'
export * from './EamLocationPermissions'
export * from './EamMeterEntryPermissions'
export * from './EamPartPermissions'
export * from './EamPurchaseOrderPermissions'
export * from './EamServiceEntryPermissions'
export * from './EamServiceProgramPermissions'
export * from './EamServiceReminderPermissions'
export * from './EamServiceSchedulePermissions'
export * from './EamServiceScheduleTaskPermissions'
export * from './EamServiceTaskPermissions'
export * from './EamSettingPermissions'
export * from './EamVendorPermissions'
export * from './EamWorkOrderPermissions'
export * from './EdiBrokerConfigurationPermissions'
export * from './EdiEligibilityCheckPermissions'
export * from './EngagePermissions'
export * from './EngageReportingPermissions'
export * from './EventPermissions'
export * from './FarePassPermissions'
export * from './FareRulePermissions'
export * from './FavoriteLocationPermissions'
export * from './FleetPermissions'
export * from './GroupPermissions'
export * from './GtfsPermissions'
export * from './GtfsRealtimePermissions'
export * from './IvrPermissions'
export * from './JourneyPermissions'
export * from './KnowledgeEntryPermissions'
export * from './LaunchReportingPermissions'
export * from './MatchingOutcomePermissions'
export * from './NotificationSettingPermissions'
export * from './OperationalAlertsPermissions'
export * from './OrganizationPermissions'
export * from './PaymentMethodPermissions'
export * from './PaymentMethodTypePermissions'
export * from './PhoneNumberPermissions'
export * from './PlatformPermissions'
export * from './PromoPermissions'
export * from './QuickReplyPermissions'
export * from './RealizePermissions'
export * from './ResolveReportingPermissions'
export * from './RequestPermissions'
export * from './ReviewPermissions'
export * from './RiderDriverRestrictionPermissions'
export * from './RiderPermissions'
export * from './RiderRepresentativePermissions'
export * from './RiderRiderRestrictionPermissions'
export * from './RiderUserPermissions'
export * from './RiderVehicleTypeRestrictionPermissions'
export * from './ServicePermissions'
export * from './SidebarProductVisibilityPermissions'
export * from './SuperAdmin/DefaultSuperAdminPermissions'
export * from './SuperAdmin/EngineeringLeadPermissions'
export * from './SuperAdmin/PartnerSuccessPermissions'
export * from './SuperAdmin/RootSuperAdminPermissions'
export * from './SuperAdmin/SiteReliabilityEngineerPermissions'
export * from './SuperAdmin/SuperAdminTestPermission'
export * from './TicketPermissions'
export * from './TimeRulePermissions'
export * from './TipPermissions'
export * from './TripGroupPermissions'
export * from './UserBanPermissions'
export * from './UserFleetAgreementPermissions'
export * from './UserOnlyTokenPermissions'
export * from './UserOwnPermissions'
export * from './VehiclePermissions'
export * from './VehicleTypePermissions'
export * from './WebhookPermissions'
export * from './WorkflowPermissions'

/**
 * Please add new permission sets to this type
 */
export type PermissionSetType =
  | AnalyticsTemplateLibraryPermissionSet
  | AccessGrantPermissionSet
  | AdminUserPermissionSet
  | AiAgentPermissionSet
  | AiPermissionSet
  | AnalyticsPermissionSet
  | AnnouncementPermissionSet
  | ApiKeyPermissionSet
  | AppPermissionSet
  | AuditLogPermissionSet
  | DirectorySyncPermissionSet
  | AuthorizationGroupPermissionSet
  | AuthorizationGroupMembershipPermissionSet
  | AuthorizationRolePermissionSet
  | BulkMessagePermissionSet
  | CancellationReasonPermissionSet
  | CasePermissionSet
  | CaseTypePermissionSet
  | ChargePermissionSet
  | CustomLinkPermissionSet
  | DataRetentionSchedulePermissionSet
  | DevicePermissionSet
  | DriverPermissionSet
  | DriverUserPermissionSet
  | DutyPermissionSet
  | DriverBreakPermissionSet
  | DutyRequestOfferPermissionSet
  | EngageReportingPermissionSet
  | EventPermissionSet
  | FarePassPermissionSet
  | FareRulePermissionSet
  | FavoriteLocationPermissionSet
  | FixedRouteForDisplayPermissionSet
  | FleetPermissionSet
  | FormPermissionSet
  | GroupPermissionSet
  | GtfsRealtimePermissionSet
  | IvrPermissionSet
  | JourneyPermissionSet
  | DutyDelayPermissionSet
  | KnowledgeEntryPermissionSet
  | PlatformPermissionSet
  | LaunchReportingPermissionSet
  | LetterPermissionSet
  | NotificationDeliveryPolicyPermissionSet
  | NotificationSettingPermissionSet
  | MatchingOutcomePermissionSet
  | OperationalAlertsPermissionSet
  | ProviderPermissionSet
  | OrganizationPermissionSet
  | PaymentMethodPermissionSet
  | PaymentMethodTypePermissionSet
  | PhoneNumberPermissionSet
  | PromoPermissionSet
  | RealizePermissionSet
  | ResolveReportingPermissionSet
  | RequestPermissionSet
  | ReviewPermissionSet
  | RiderPermissionSet
  | RiderDriverRestrictionPermissionSet
  | RiderRiderRestrictionPermissionSet
  | RiderOnboardingFlowPermissionSet
  | RiderVehicleTypeRestrictionPermissionSet
  | RiderRepresentativePermissionSet
  | RiderUserPermissionSet
  | SidebarProductVisibilityPermissionSet
  | ServicePermissionSet
  | TicketPermissionSet
  | TimeRulePermissionSet
  | TipPermissionSet
  | UserBanPermissionSet
  | UserFleetAgreementPermissionSet
  | UserOnlyTokenPermissionSet
  | UserOwnPermissionSet
  | VehiclePermissionSet
  | VehicleTypePermissionSet
  | WebhookPermissionSet
  | WorkflowPermissionSet
  | EamAssetPermissionSet
  | EamContactPermissionSet
  | NylasAdminGrantPermissionSet
  | DefaultSuperAdminPermissionSet
  | EngineeringLeadPermissionSet
  | PartnerSuccessPermissionSet
  | RootSuperAdminPermissionSet
  | SiteReliabilityEngineerPermissionSet
  | SuperAdminTestRolePermissionSet
  | CommentPermissionSet
  | EamMeterEntryPermissionSet
  | EamServiceTaskPermissionSet
  | EamServiceProgramPermissionSet
  | EamServiceSchedulePermissionSet
  | EamServiceScheduleTaskPermissionSet
  | EamServiceReminderPermissionSet
  | EamWorkOrderPermissionSet
  | EamServiceEntryPermissionSet
  | EamPartPermissionSet
  | EamIssuePermissionSet
  | TripGroupPermissionSet
  | EdiBrokerConfigurationPermissionSet
  | EdiEligibilityCheckPermissionSet
  | EamInventoryPermissionSet
  | EamLocationPermissionSet
  | EamPurchaseOrderPermissionSet
  | EamVendorPermissionSet
  | EamInspectionFormPermissionSet
  | EamInspectionPermissionSet
  | EamSettingPermissionSet
  | EamEnergyEntryPermissionSet
  | QuickReplyPermissionSet
  | GtfsPermissionsSet

/**
 * Please add all permission set groupings to this array.
 *
 * The order permission set groupings appear in this list will be reflected in the Role creation user interface.
 */
export const permissionSetGroupings: Array<IPermissionSetGrouping<string>> = [
  /*
   * Access * groupings
   **/

  platformPermissionSetGrouping,
  sidebarProductVisibilityPermissionSetGrouping,
  analyticsPermissionSetGrouping,
  analyticsTemplateLibraryPermissionSetGrouping,
  realizePermissionSetGrouping,

  /*
   * Roles + users groupings
   **/

  authorizationGroupPermissionSetGrouping,
  authorizationRolePermissionSetGrouping,
  accessGrantPermissionSetGrouping,
  authorizationGroupMembershipPermissionSetGrouping,
  adminUserPermissionSetGrouping,
  driverUserPermissionSetGrouping,
  riderUserPermissionSetGrouping,
  userOwnPermissionSetGrouping,

  /*
   * Broadly applicable groupings
   **/

  organizationPermissionSetGrouping,
  userBanPermissionSetGrouping,
  eventPermissionSetGrouping,
  commentPermissionSetGrouping,
  dataRetentionSchedulePermissionSetGrouping,

  /*
   * Announcements and notifications groupings
   **/

  notificationSettingPermissionSetGrouping,
  announcementPermissionSetGrouping,
  bulkMessagePermissionSetGrouping,
  operationalAlertsPermissionSetGrouping,

  /*
   * Operations groupings
   **/

  launchReportingPermissionSetGrouping,
  requestPermissionSetGrouping,
  journeyPermissionSetGrouping,
  favoriteLocationPermissionSetGrouping,
  servicePermissionSetGrouping,
  timeRulePermissionSetGrouping,
  fleetPermissionSetGrouping,
  vehiclePermissionSetGrouping,
  vehicleTypePermissionSetGrouping,
  dutyPermissionSetGrouping,
  dutyRequestOfferPermissionSetGrouping,
  driverBreakPermissionSetGrouping,
  matchingOutcomePermissionSetGrouping,
  cancellationReasonPermissionSetGrouping,
  riderDriverRestrictionPermissionSetGrouping,
  riderRiderRestrictionPermissionSetGrouping,
  riderVehicleTypeRestrictionPermissionSetGrouping,
  riderRepresentativePermissionSetGrouping,
  userFleetAgreementPermissionSetGrouping,
  reviewPermissionSetGrouping,
  dutyDelayPermissionSetGrouping,
  quickReplyPermissionSetGrouping,
  tripGroupPermissionSetGrouping,
  providerPermissionSetGrouping,

  /*
   * GTFS groupings
   **/
  gtfsPermissionSetGrouping,

  /*
   * GTFS Realtime groupings
   **/
  gtfsRealtimePermissionSetGrouping,

  /*
   * Fixed Route For Display groupings
   **/
  fixedRouteForDisplayPermissionSetGrouping,

  /*
   * AI Voice / IVR groupings
   **/

  aiAgentPermissionSetGrouping,
  ivrPermissionSetGrouping,
  aiPermissionSetGrouping,
  knowledgeEntryPermissionSetGrouping,
  phoneNumberPermissionSetGrouping,

  /*
   * Payment groupings
   **/

  paymentMethodTypePermissionSetGrouping,
  paymentMethodPermissionSetGrouping,
  chargePermissionSetGrouping,
  farePassPermissionSetGrouping,
  promoPermissionSetGrouping,
  fareRulePermissionSetGrouping,
  ticketPermissionSetGrouping,
  tipPermissionSetGrouping,

  /*
   * Engage groupings
   **/

  engageReportingPermissionSetGrouping,
  groupPermissionSetGrouping,
  casePermissionSetGrouping,
  caseTypePermissionSetGrouping,
  formPermissionSetGrouping,
  letterPermissionSetGrouping,
  nylasAdminGrantPermissionSetGrouping,

  /*
   * Resolve groupings
   **/

  resolveReportingPermissionSetGrouping,

  /*
   * Mobile-related groupings
   **/
  riderOnboardingFlowPermissionSetGrouping,
  devicePermissionSetGrouping,
  customLinkPermissionSetGrouping,

  /*
   * Developer-centric groupings
   **/

  webhookPermissionSetGrouping,
  workflowPermissionSetGrouping,

  /*
   * EAM groupings
   **/

  eamAssetPermissionSetGrouping,
  eamContactPermissionSetGrouping,
  eamMeterEntryPermissionSetGrouping,
  eamServiceTaskPermissionSetGrouping,
  eamServiceProgramPermissionSetGrouping,
  eamServiceSchedulePermissionSetGrouping,
  eamServiceScheduleTaskPermissionSetGrouping,
  eamServiceReminderPermissionSetGrouping,
  eamWorkOrderPermissionSetGrouping,
  eamServiceEntryPermissionSetGrouping,
  eamPartPermissionSetGrouping,
  eamIssuePermissionSetGrouping,
  eamInventoryPermissionSetGrouping,
  eamLocationPermissionSetGrouping,
  eamPurchaseOrderPermissionSetGrouping,
  eamVendorPermissionSetGrouping,
  eamInspectionFormPermissionSetGrouping,
  eamInspectionPermissionSetGrouping,
  eamSettingPermissionSetGrouping,
  eamEnergyEntryPermissionSetGrouping,

  /*
   * Directory sync groupings
   **/

  directorySyncPermissionSetGrouping,

  /*
   * Security groupings
   **/

  auditLogPermissionSetGrouping,

  /*
   * Deprecated or non-visible groupings
   **/

  appPermissionSetGrouping,
  driverPermissionSetGrouping,
  riderPermissionSetGrouping,
  apiKeyPermissionSetGrouping,
  defaultSuperAdminPermissionSetGrouping,
  engineeringLeadPermissionSetGrouping,
  partnerSuccessPermissionSetGrouping,
  rootSuperAdminPermissionSetGrouping,
  siteReliabilityEngineerPermissionSetGrouping,
  superAdminTestRolePermissionSetGrouping,
  userOnlyTokenPermissionSetGrouping,

  /*
   *  Unsorted groupings (please find a good place for your new permission set grouping, groupings that end up here will just end up at the end of the list)
   **/

  ediBrokerConfigurationPermissionSetGrouping,
  ediEligibilityCheckPermissionSetGrouping,
]

/**
 * Please add all active permission sets to this object.
 */
export const PermissionSets: Record<PermissionSetType, PermissionType[]> = {
  ...accessGrantPermissionSetGrouping.active,
  ...adminUserPermissionSetGrouping.active,
  ...analyticsTemplateLibraryPermissionSetGrouping.active,
  ...aiAgentPermissionSetGrouping.active,
  ...aiPermissionSetGrouping.active,
  ...analyticsPermissionSetGrouping.active,
  ...announcementPermissionSetGrouping.active,
  ...apiKeyPermissionSetGrouping.active,
  ...appPermissionSetGrouping.active,
  ...authorizationGroupPermissionSetGrouping.active,
  ...authorizationGroupMembershipPermissionSetGrouping.active,
  ...authorizationRolePermissionSetGrouping.active,
  ...bulkMessagePermissionSetGrouping.active,
  ...cancellationReasonPermissionSetGrouping.active,
  ...casePermissionSetGrouping.active,
  ...caseTypePermissionSetGrouping.active,
  ...chargePermissionSetGrouping.active,
  ...customLinkPermissionSetGrouping.active,
  ...dataRetentionSchedulePermissionSetGrouping.active,
  ...devicePermissionSetGrouping.active,
  ...driverPermissionSetGrouping.active,
  ...driverUserPermissionSetGrouping.active,
  ...dutyPermissionSetGrouping.active,
  ...dutyRequestOfferPermissionSetGrouping.active,
  ...driverBreakPermissionSetGrouping.active,
  ...engageReportingPermissionSetGrouping.active,
  ...eventPermissionSetGrouping.active,
  ...fleetPermissionSetGrouping.active,
  ...commentPermissionSetGrouping.active,
  ...farePassPermissionSetGrouping.active,
  ...fareRulePermissionSetGrouping.active,
  ...favoriteLocationPermissionSetGrouping.active,
  ...formPermissionSetGrouping.active,
  ...ivrPermissionSetGrouping.active,
  ...journeyPermissionSetGrouping.active,
  ...knowledgeEntryPermissionSetGrouping.active,
  ...phoneNumberPermissionSetGrouping.active,
  ...dutyDelayPermissionSetGrouping.active,
  ...riderPermissionSetGrouping.active,
  ...groupPermissionSetGrouping.active,
  ...gtfsPermissionSetGrouping.active,
  ...gtfsRealtimePermissionSetGrouping.active,
  ...platformPermissionSetGrouping.active,
  ...launchReportingPermissionSetGrouping.active,
  ...letterPermissionSetGrouping.active,
  ...matchingOutcomePermissionSetGrouping.active,
  ...NotificationDeliveryPolicyPermissionSetGrouping.active,
  ...notificationSettingPermissionSetGrouping.active,
  ...operationalAlertsPermissionSetGrouping.active,
  ...providerPermissionSetGrouping.active,
  ...organizationPermissionSetGrouping.active,
  ...paymentMethodPermissionSetGrouping.active,
  ...paymentMethodTypePermissionSetGrouping.active,
  ...promoPermissionSetGrouping.active,
  ...realizePermissionSetGrouping.active,
  ...resolveReportingPermissionSetGrouping.active,
  ...requestPermissionSetGrouping.active,
  ...reviewPermissionSetGrouping.active,
  ...riderDriverRestrictionPermissionSetGrouping.active,
  ...riderRiderRestrictionPermissionSetGrouping.active,
  ...riderOnboardingFlowPermissionSetGrouping.active,
  ...riderVehicleTypeRestrictionPermissionSetGrouping.active,
  ...riderUserPermissionSetGrouping.active,
  ...sidebarProductVisibilityPermissionSetGrouping.active,
  ...servicePermissionSetGrouping.active,
  ...ticketPermissionSetGrouping.active,
  ...timeRulePermissionSetGrouping.active,
  ...tipPermissionSetGrouping.active,
  ...userBanPermissionSetGrouping.active,
  ...userFleetAgreementPermissionSetGrouping.active,
  ...userOwnPermissionSetGrouping.active,
  ...vehiclePermissionSetGrouping.active,
  ...vehicleTypePermissionSetGrouping.active,
  ...webhookPermissionSetGrouping.active,
  ...workflowPermissionSetGrouping.active,
  ...eamAssetPermissionSetGrouping.active,
  ...eamContactPermissionSetGrouping.active,
  ...riderRepresentativePermissionSetGrouping.active,
  ...nylasAdminGrantPermissionSetGrouping.active,
  ...defaultSuperAdminPermissionSetGrouping.active,
  ...engineeringLeadPermissionSetGrouping.active,
  ...partnerSuccessPermissionSetGrouping.active,
  ...rootSuperAdminPermissionSetGrouping.active,
  ...siteReliabilityEngineerPermissionSetGrouping.active,
  ...superAdminTestRolePermissionSetGrouping.active,
  ...userOnlyTokenPermissionSetGrouping.active,
  ...eamMeterEntryPermissionSetGrouping.active,
  ...eamServiceTaskPermissionSetGrouping.active,
  ...eamServiceProgramPermissionSetGrouping.active,
  ...eamServiceSchedulePermissionSetGrouping.active,
  ...eamServiceScheduleTaskPermissionSetGrouping.active,
  ...eamServiceReminderPermissionSetGrouping.active,
  ...eamWorkOrderPermissionSetGrouping.active,
  ...eamServiceEntryPermissionSetGrouping.active,
  ...eamPartPermissionSetGrouping.active,
  ...eamIssuePermissionSetGrouping.active,
  ...tripGroupPermissionSetGrouping.active,
  ...auditLogPermissionSetGrouping.active,
  ...directorySyncPermissionSetGrouping.active,
  ...ediEligibilityCheckPermissionSetGrouping.active,
  ...ediBrokerConfigurationPermissionSetGrouping.active,
  ...eamInventoryPermissionSetGrouping.active,
  ...eamLocationPermissionSetGrouping.active,
  ...eamPurchaseOrderPermissionSetGrouping.active,
  ...eamVendorPermissionSetGrouping.active,
  ...eamInspectionFormPermissionSetGrouping.active,
  ...eamInspectionPermissionSetGrouping.active,
  ...eamSettingPermissionSetGrouping.active,
  ...eamEnergyEntryPermissionSetGrouping.active,
  ...fixedRouteForDisplayPermissionSetGrouping.active,
  ...quickReplyPermissionSetGrouping.active,
}

/**
 * List of permission sets that should be hidden in the UI
 */
export const UnAssignablePermissionSets: PermissionSetType[] = permissionSetGroupings.reduce<PermissionSetType[]>(
  (acc, grouping: IPermissionSetGrouping<string>) => {
    acc.push(...(grouping.unAssignablePermissionSets as PermissionSetType[]))
    return acc
  },
  [],
)

export const PermissionSetsForPermissionType: Record<PermissionType, PermissionSetType[]> = Object.entries(
  PermissionSets,
).reduce(
  (output, [permissionSetType, permissionTypes]) => {
    for (const permissionType of permissionTypes) {
      if (UnAssignablePermissionSets.includes(permissionSetType as PermissionSetType)) {
        continue
      }

      if (!output[permissionType]) {
        output[permissionType] = []
      }
      output[permissionType].push(permissionSetType as PermissionSetType)
    }

    return output
  },
  {} as Record<PermissionType, PermissionSetType[]>,
)

/**
 * List of permission sets that are super admin sets
 */
export const SuperAdminPermissionSets: PermissionSetType[] = permissionSetGroupings.reduce<PermissionSetType[]>(
  (acc, grouping: IPermissionSetGrouping<string>) => {
    if (grouping.isSuperAdminSet) {
      const keys = Object.keys(grouping.active)
      for (const key of keys) {
        acc.push(key as PermissionSetType)
      }
    }
    return acc
  },
  [],
)
